import { useIntl } from 'react-intl'

import { makePublicUrl } from 'app/utils/publicUrl'
import { purchaseSubscriptionMessages } from 'features/networkAi/NetworkWizard/PurchaseDeviceSubscription/messages'

import {
  SubscriptionStatusDashboardWrapper,
  PurchaseStateCardSubtitleWrapper,
  PurchaseStateCardSubtitle,
  PurchaseStateCardCountSubtitle,
  PurchaseClaimCardCountSubtitle,
  PurchaseSubscriptionScrolledContentBlock,
  PurchaseSubscriptionFinalBlockWrapper,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionItemTitle,
  StyledPurchaseItemImg,
} from './styles'
import { networkStatusMessages } from 'features/networkAi/NetworkDashboard/NetworkStatus/NetworkStatusSubscription/messages'

interface SubscriptionStatusCardProps {
  claimedCount: number
  subscribedCount: number
}

function SubscriptionStatusCard({
  claimedCount,
  subscribedCount,
}: SubscriptionStatusCardProps) {
  const { formatMessage } = useIntl()

  return (
    <SubscriptionStatusDashboardWrapper>
      <PurchaseSubscriptionScrolledContentBlock>
        <PurchaseSubscriptionFinalBlockWrapper disabled={false}>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.accessPointsLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/access-points.svg`)}
            />
            <PurchaseStateCardSubtitleWrapper>
              <PurchaseStateCardSubtitle>
                <PurchaseClaimCardCountSubtitle>
                  {claimedCount}
                </PurchaseClaimCardCountSubtitle>
                {formatMessage(networkStatusMessages.subClaimedText)}
              </PurchaseStateCardSubtitle>
              <PurchaseStateCardSubtitle>
                <PurchaseStateCardCountSubtitle
                  isSuccess={subscribedCount >= claimedCount}
                >
                  {subscribedCount}
                </PurchaseStateCardCountSubtitle>
                {formatMessage(networkStatusMessages.subSubscribedText)}
              </PurchaseStateCardSubtitle>
            </PurchaseStateCardSubtitleWrapper>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>

        <PurchaseSubscriptionFinalBlockWrapper disabled={true}>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.switchesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/switches.svg`)}
            />
            <PurchaseStateCardSubtitleWrapper>
              <PurchaseStateCardSubtitle>
                <PurchaseClaimCardCountSubtitle></PurchaseClaimCardCountSubtitle>
              </PurchaseStateCardSubtitle>
              <PurchaseStateCardSubtitle>
                <PurchaseClaimCardCountSubtitle></PurchaseClaimCardCountSubtitle>
                {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
              </PurchaseStateCardSubtitle>
            </PurchaseStateCardSubtitleWrapper>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>

        <PurchaseSubscriptionFinalBlockWrapper disabled={true}>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.wanEdgesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/wan-edges.svg`)}
            />
            <PurchaseStateCardSubtitleWrapper>
              <PurchaseStateCardSubtitle>
                <PurchaseClaimCardCountSubtitle></PurchaseClaimCardCountSubtitle>
              </PurchaseStateCardSubtitle>
              <PurchaseStateCardSubtitle>
                <PurchaseClaimCardCountSubtitle></PurchaseClaimCardCountSubtitle>
                {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
              </PurchaseStateCardSubtitle>
            </PurchaseStateCardSubtitleWrapper>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>
      </PurchaseSubscriptionScrolledContentBlock>
    </SubscriptionStatusDashboardWrapper>
  )
}

export default SubscriptionStatusCard
